import type { PageMeta } from '@/lib/api';

export function pageCount(meta: PageMeta): number {
  return Math.max(1, Math.ceil(meta.total / meta.pageSize));
}

export function rangeLabel(meta: PageMeta): string {
  if (meta.total === 0) return '0 results';
  const from = (meta.page - 1) * meta.pageSize + 1;
  const to = Math.min(meta.page * meta.pageSize, meta.total);
  return `${from}–${to} of ${meta.total}`;
}
